<!-- eslint-disable -->
<template lang="pug">
    div.datepicker-input-container
        date-input(
            :selectedDate="selectedDate",
            :format="format",
            :translation="translation",
            :inline="inline",
            :id="id",
            :name="name",
            :openDate="openDate",
            :placeholder="placeholder",
            :typeable="typeable",
            :clearButton="clearButton",
            :clearButtonIcon="clearButtonIcon",
            :calendarButton="calendarButton",
            :calendarButtonIcon="calendarButtonIcon",
            :calendarButtonIconContent="calendarButtonIconContent",
            :disabled="disabled",
            :required="required",
            :error="error",
            @showCalendar="showCalendar",
            @closeCalendar="close",
            @typedDate="setTypedDate",
            @clearDate="clearDate",
            ref="dateInput"
        )

        transition(
          name="fade",
          enter-active-class="datepicker-container--enter-active",
          leave-active-class="datepicker-container--leave-active",
          enter-class="datepicker-container--enter",
          leave-to-class="datepicker-container--leave-to"
        )
            box.datepicker-container(
                v-show="isOpen",
                shadow="base",
                :class="[pickerAbove && 'datepicker-container--above']",
                ref="datePicker"
            )
                picker-day(
                    v-if="allowedToShowView('day') && showDayView",
                    :pageDate="pageDate",
                    :selectedDate="selectedDate",
                    :showDayView="showDayView",
                    :fullMonthName="true",
                    :allowedToShowView="allowedToShowView",
                    :disabledDates="disabledDates",
                    :highlighted="highlighted",
                    :translation="translation",
                    :pageTimestamp="pageTimestamp",
                    :isRtl="isRtl",
                    :mondayFirst="true",
                    @changedMonth="setPageDate",
                    @selectDate="selectDate",
                    @showMonthCalendar="showMonthCalendar",
                    @selectedDisabled="$emit('selectedDisabled')"
                )

                picker-month(
                    v-else-if="allowedToShowView('month') && showMonthView",
                    :pageDate="pageDate",
                    :selectedDate="selectedDate",
                    :showMonthView="showMonthView",
                    :allowedToShowView="allowedToShowView",
                    :disabledDates="disabledDates",
                    :calendarClass="calendarClass",
                    :calendarStyle="calendarStyle",
                    :translation="translation",
                    @selectMonth="selectMonth",
                    @showYearCalendar="showYearCalendar",
                    @changedYear="setPageDate"
                )

                picker-year(
                    v-else-if="allowedToShowView('year') && showYearView",
                    :pageDate="pageDate",
                    :selectedDate="selectedDate",
                    :showYearView="showYearView",
                    :allowedToShowView="allowedToShowView",
                    :disabledDates="disabledDates",
                    :calendarClass="calendarClass",
                    :calendarStyle="calendarStyle",
                    :translation="translation",
                    @selectYear="selectYear",
                    @changedDecade="setPageDate"
                )
</template>

<script>
    /*eslint-disable*/
    import VueDatepicker from "vuejs-datepicker"
    import ru from "vuejs-datepicker/dist/locale/translations/ru.js"
    import en from "vuejs-datepicker/dist/locale/translations/en.js"
    import bg from "vuejs-datepicker/dist/locale/translations/bg.js"
    import lv from "vuejs-datepicker/dist/locale/translations/lv.js"
    import DateInput from "./Datepicker/DateInput.vue"
    import PickerDay from "./Datepicker/PickerDay.vue"
    import PickerMonth from "./Datepicker/PickerMonth.vue"
    import PickerYear from "./Datepicker/PickerYear.vue"
    import Box from "./Box.vue"

    /**
     * More information about properties: https://github.com/charliekassel/vuejs-datepicker#available-props
     */
    export default {
        extends: VueDatepicker,
        name: "CsDatepicker",
        status: "ready",
        release: "1.0.0",
        components: {
            Box,
	          DateInput,
	          PickerDay,
	          PickerMonth,
	          PickerYear,
        },
        props: {
            /**
             * Current Datepicker language
             */
            language: {
                type: String,
                default: "ru",
            },
            /**
             * Error state of Datepicker
             */
            error: {
                type: Boolean,
                default: false,
            },
            /**
             * Multiply state of Datepicker
             */
            isMultiply: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                pickerAbove: false,
                languages: {
                    ru: ru,
                    en: en,
                    bg: bg,
                    lv: lv,
                },
            }
        },
        watch: {
            isOpen(val) {
                if (val) {
                    this.$nextTick(() => {
                        this.setPickerXPosition()
                        this.setPickerYPosition()
                    })
                }
            },
        },
        computed: {
          translation() {
            return this.language && this.languages[this.language] ? this.languages[this.language] : ru
          },
        },
        methods: {
            setPickerXPosition() {
                let windowWidth = window.innerWidth
                if (windowWidth > 640) {
                    return
                }
                let inputPosition = this.$refs.dateInput.$el.getBoundingClientRect()
                let style = this.$refs.datePicker.$el.style
                if (windowWidth - inputPosition.right < inputPosition.left) {
                    style.right = 0
                    style.left = "auto"
                } else {
                    style.left = 0
                    style.right = "auto"
                }
            },
            setPickerYPosition() {
                let windowHeight = window.innerHeight
                let pickerHeight = this.$refs.datePicker.$el.offsetHeight
                let inputPosition = this.$refs.dateInput.$el.getBoundingClientRect()
                this.pickerAbove = inputPosition.bottom + pickerHeight > windowHeight
            },
            selectDate (date) {
                this.setDate(date.timestamp);
                if (!this.isInline && !this.isMultiply) {
                    this.close(true);
                }
                this.resetTypedDate = new Date();
            },
            setDate (timestamp) {
                const date = new Date(timestamp)
                if (!this.isInline && !this.isMultiply) {
                    this.selectedDate = date
                }
                this.setPageDate(date)
                this.$emit('selected', date)
                this.$emit('input', date)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .datepicker-input-container {
		    @include stack-space($space-small);
        position: relative;
    }
    .datepicker-input-container--no-margin {
		    margin: 0;
    }
    .datepicker-container {
        position: absolute;
        z-index: $z-index-dropdown;
        width: 242px;
        background-color: $x-color-white;
		    @include inset-space($space-small);
        border-radius: $border-radius-6;
    }

    .datepicker-container--above {
        bottom: 100%;
    }

    .datepicker-container--enter-active,
    .datepicker-container--leave-active {
        transition: opacity 0.3s, transform 0.3s;
    }

    .datepicker-container--enter,
    .datepicker-container--leave-to {
        transform: translateY($space-x-small);
        opacity: 0;
    }
</style>
